import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-sports', templateUrl: './sports.component.html', styleUrls: ['./sports.component.scss'] })
export class SportsComponent implements OnInit {

  sportsImages = [
    '/assets/img/quick-links/sports/1 (1).jpg',
    '/assets/img/quick-links/sports/1 (2).jpg',
    '/assets/img/quick-links/sports/1 (3).jpg',
    '/assets/img/quick-links/sports/1 (4).jpg',
    '/assets/img/quick-links/sports/1 (5).jpg',
    '/assets/img/quick-links/sports/1 (6).jpg',
    '/assets/img/quick-links/sports/1 (7).jpg',
    '/assets/img/quick-links/sports/1 (8).jpg',
    '/assets/img/quick-links/sports/1 (9).jpg',
    '/assets/img/quick-links/sports/1 (10).jpg',
    '/assets/img/quick-links/sports/1 (11).jpg',
    '/assets/img/quick-links/sports/1 (12).jpg',
    '/assets/img/quick-links/sports/1 (13).jpg',
    '/assets/img/quick-links/sports/1 (14).jpg',
    '/assets/img/quick-links/sports/1 (15).jpg',
    '/assets/img/quick-links/sports/1 (16).jpg',
    '/assets/img/quick-links/sports/1 (17).jpg',
    '/assets/img/quick-links/sports/1 (18).jpg',
    '/assets/img/quick-links/sports/1 (19).jpg',
    '/assets/img/quick-links/sports/1 (20).jpg',
    '/assets/img/quick-links/sports/1 (21).jpg',
    '/assets/img/quick-links/sports/1 (22).jpg',
    '/assets/img/quick-links/sports/1 (23).jpg',
    '/assets/img/quick-links/sports/1 (24).jpg',
    '/assets/img/quick-links/sports/1 (25).jpg',
    '/assets/img/quick-links/sports/1 (26).jpg',
    '/assets/img/quick-links/sports/1 (27).jpg',
    '/assets/img/quick-links/sports/1 (28).jpg',
    '/assets/img/quick-links/sports/1 (29).jpg',
    '/assets/img/quick-links/sports/1 (30).jpg',
    '/assets/img/quick-links/sports/1 (31).jpg',
    '/assets/img/quick-links/sports/1 (32).jpg',
    '/assets/img/quick-links/sports/1 (33).jpg',
    '/assets/img/quick-links/sports/1 (34).jpg',
    '/assets/img/quick-links/sports/1 (35).jpg',
    '/assets/img/quick-links/sports/1 (36).jpg',
    '/assets/img/quick-links/sports/1 (37).jpg',
    '/assets/img/quick-links/sports/1 (38).jpg',
    '/assets/img/quick-links/sports/1 (39).jpg',
    '/assets/img/quick-links/sports/1 (40).jpg',
    '/assets/img/quick-links/sports/1 (41).jpg',
    '/assets/img/quick-links/sports/1 (42).jpg',
    '/assets/img/quick-links/sports/1 (43).jpg',
    '/assets/img/quick-links/sports/1 (44).jpg',
    '/assets/img/quick-links/sports/1 (45).jpg',
    '/assets/img/quick-links/sports/1 (46).jpg',
    '/assets/img/quick-links/sports/1 (47).jpg',
    '/assets/img/quick-links/sports/1 (48).jpg',
    '/assets/img/quick-links/sports/1 (49).jpg',
    '/assets/img/quick-links/sports/1 (50).jpg',
    '/assets/img/quick-links/sports/1 (51).jpg',
    '/assets/img/quick-links/sports/1 (52).jpg',
    '/assets/img/quick-links/sports/1 (53).jpg',
    '/assets/img/quick-links/sports/1 (54).jpg',
    '/assets/img/quick-links/sports/1 (55).jpg',
    '/assets/img/quick-links/sports/1 (56).jpg',
    '/assets/img/quick-links/sports/1 (57).jpg',
    '/assets/img/quick-links/sports/1 (58).jpg',
    '/assets/img/quick-links/sports/1 (59).jpg',
    '/assets/img/quick-links/sports/1 (60).jpg',
    '/assets/img/quick-links/sports/1 (61).jpg',
    '/assets/img/quick-links/sports/1 (62).jpg',
    '/assets/img/quick-links/sports/1 (63).jpg',
    '/assets/img/quick-links/sports/1 (64).jpg',
    '/assets/img/quick-links/sports/1 (65).jpg',
    '/assets/img/quick-links/sports/1 (66).jpg',
    '/assets/img/quick-links/sports/1 (67).jpg',
    '/assets/img/quick-links/sports/1 (68).jpg',
    '/assets/img/quick-links/sports/1 (69).jpg',
    '/assets/img/quick-links/sports/1 (70).jpg',
    '/assets/img/quick-links/sports/1 (71).jpg',
    '/assets/img/quick-links/sports/1 (72).jpg',
    '/assets/img/quick-links/sports/1 (73).jpg',
    '/assets/img/quick-links/sports/1 (74).jpg',
    '/assets/img/quick-links/sports/1 (75).jpg',
    '/assets/img/quick-links/sports/1 (76).jpg',
    '/assets/img/quick-links/sports/1 (77).jpg',
    '/assets/img/quick-links/sports/1 (78).jpg',
    '/assets/img/quick-links/sports/1 (79).jpg',
    '/assets/img/quick-links/sports/1 (80).jpg',
    '/assets/img/quick-links/sports/1 (81).jpg',
    '/assets/img/quick-links/sports/1 (82).jpg',
    '/assets/img/quick-links/sports/1 (83).jpg',
    '/assets/img/quick-links/sports/1 (84).jpg',
    '/assets/img/quick-links/sports/1 (85).jpg',
    '/assets/img/quick-links/sports/1 (86).jpg',
    '/assets/img/quick-links/sports/1 (87).jpg',
    '/assets/img/quick-links/sports/1 (88).jpg',
    '/assets/img/quick-links/sports/1 (89).jpg',
  ];

  constructor() { }
  ngOnInit(): void { }
}
